export function AddChildConstructor(services, type, label) {

  const DEFAULT_BOX_WIDTH = 250;
  const joint = services.joint;

  return joint.shapes.devs.Model.extend({
    markup: '<g class="rotatable"><rect class="body"/></g>',
    portLabelMarkup: '',
    defaults: joint.util.deepSupplement({
      type: type,
      label: label,
      z: 20,
      size: { width: DEFAULT_BOX_WIDTH, height: 50 },
      attrs: {
        '.body': {stroke: 'none', 'fill': '#FFFFFF', 'fill-opacity': 0.9}
      }
    }, joint.shapes.devs.Model.prototype.defaults)
  });

}
